import { defineComponent } from 'vue'
import { store } from '#stores/oneform'
import { Contact } from '#models/contact'
import ContactFieldsVue from '../ContactFields/ContactFields.vue'
import SignaturePadVue from '../SignaturePad/SignaturePad.vue'

export default defineComponent({
  components: {
    ContactFields: ContactFieldsVue,
    SignaturePad: SignaturePadVue
  },
  data() {
      const form = store.authorizationDisclosureForm
      const patientForm = store.patientForm
    while (form.authorizedContacts.length < 2)
      form.authorizedContacts.add(new Contact())
    return {
        form,
        patientForm
    }
  }
})
